import { useAuth } from "@/providers";
import { useHasOrgRole, useSystemUser } from "@/providers/auth/hooks";
import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks";
import { OrganizationTier } from "@/shared/domain/orgs";

import { OrgLlmConnectionsSection } from "../OrgLlmConnections/OrgLlmConnectionsSection";

import { OrgAiModelsSection } from "./OrgAiModelsSection";

/**
 * The current org's AI models and LLM connections sections, with edit rights
 * resolved from the signed-in user: org admins and owners edit, as do Roboto
 * admins (who add Roboto models from the Bedrock catalog rather than the
 * template); every other member reads. The LLM connections section, and
 * adding models on a connection, show only while the org's
 * `ai-own-llm-connections` flag is on (read as off while it loads).
 */
export function CurrentOrgAiModels() {
  const { currentOrganization } = useAuth();
  const canEdit = useHasOrgRole("admin");
  const { isSystemUser } = useSystemUser();
  const ownConnectionsEnabled = useCheckFeatureFlag(
    "ai-own-llm-connections",
    currentOrganization?.org_id,
  );

  if (!currentOrganization) {
    return null;
  }
  const isPremium = currentOrganization.tier === OrganizationTier.Premium;
  return (
    <>
      <OrgAiModelsSection
        orgId={currentOrganization.org_id}
        canEdit={canEdit}
        isRobotoAdmin={isSystemUser}
        isPremium={isPremium}
        ownConnectionsEnabled={ownConnectionsEnabled}
      />
      {ownConnectionsEnabled && (
        <OrgLlmConnectionsSection
          orgId={currentOrganization.org_id}
          canEdit={canEdit}
          isPremium={isPremium}
        />
      )}
    </>
  );
}
